import { ThemeUICSSObject } from '@apia/theme';
import { components } from './components';
import { iframes } from './iframes';
import { dashboards } from './dashboards';
export const common: ThemeUICSSObject = {
  components,
  dashboards,
  iframes,
  /* PREPEND HERE */
};
